import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from 'axios';
import { checkUploadFailure, checkUploadSuccess, checkUploadRequest } from '../reducers/checkInternet';
const NetworkSpeed = require('network-speed');

function* checkUploadAxios() {

  const testNetworkSpeed = new NetworkSpeed();
  const options = {
    hostname: 'www.google.com',
    port: 80,
    path: '/catchers/544b09b4599c1d0200000289',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
  };
  const fileSizeInBytes = 2000000
 
  const response = yield call(() => {
    return testNetworkSpeed.checkUploadSpeed(options, fileSizeInBytes);
  });

  return response;
}

function* workerCheckUploadSaga() {
  
  try {
    const response = yield call(checkUploadAxios);
    
    const responseFromCheckCode = response.mbps;

    yield put(checkUploadSuccess(responseFromCheckCode));
    if (response.status === 500) {
      yield put(checkUploadFailure(responseFromCheckCode));
    }
  } catch (error) {
    yield put(checkUploadFailure(error));
  }
}

export function* watcherCheckUploadSaga() {
  yield takeLatest(checkUploadRequest().type, workerCheckUploadSaga);
}
